export default "__VITE_ASSET__98f7c4ac__"